module.exports = __webpack_public_path__ + "img/navLeftBottom.2830f972.png";